@if (selectedCount > 0) {
    <div class="activity-selection-actions__count">
        <mat-icon svgIcon="activity-selection-actions__check"></mat-icon>
        <span>{{ selectedCount }} {{ 'activity_search.selected_count_label' | translate }}</span>
    </div>
    <button class="activity-selection-actions__clear-button"
            (click)="onClearSelection($event)">
        <span>{{ 'activity_search.clear_selection_button' | translate }}</span>
    </button>
    <button class="activity-selection-actions__validate-button"
            (click)="onValidateSelection($event)">
        <mat-icon svgIcon="activity-selection-actions__import"></mat-icon>
        <span>{{ 'activity_search.validate_selection_button' | translate }}</span>
    </button>
}
